import React from 'react'
import { Link } from 'react-router-dom'
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from '../../hooks/useAuth';
import { useDispatch } from 'react-redux';
import InstallButton from './InstallSnackbar';
import InstallSnackbar from './InstallSnackbar';

function Headerbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {auth,setAuth, logout} = useAuth();
  const requestorRoles = ['Common','Administrator'];
  const approverRoles = ['Administrator'];
  const makerRoles = ['Maker', 'Checker', 'Authorizer'];
  const paymentApproverRoles = ['Checker', 'Authorizer'];
  //console.log(location.pathname);
  //console.log(`auth value : ${JSON.stringify(auth)}`);
  
  const inventoryReqClass = location.pathname.match(/^\/inventoryRequest/) ? "nav-link px-2 text-white" : "nav-link px-2 text-secondary";
  // const userClass = location.pathname.match(/^\/user/) ? "nav-link px-2 text-white" : "nav-link px-2 text-secondary";
  const approveClass = location.pathname.match(/^\/approve/) ? "nav-link px-2 text-white" : "nav-link px-2 text-secondary";
  const historyClass = location.pathname.match(/^\/history/) ? "nav-link px-2 text-white" : "nav-link px-2 text-secondary";
  const reportClass = location.pathname.match(/^\/report/) ? "nav-link px-2 text-white" : "nav-link px-2 text-secondary";
  const vendorClass = location.pathname.match(/^\/vendors/) ? "nav-link px-2 text-white" : "nav-link px-2 text-secondary";
  const paymentRequestClass = location.pathname.match(/^\/paymentrequest/) ? "nav-link px-2 text-white" : "nav-link px-2 text-secondary";
  const paymentRequestHistoryClass = location.pathname.match(/^\/paymenthistory/) ? "nav-link px-2 text-white" : "nav-link px-2 text-secondary";
  const paymentRequestApproveClass = location.pathname.match(/^\/paymentapprove/) ? "nav-link px-2 text-white" : "nav-link px-2 text-secondary";
  // const paymentReportClass = location.pathname.match(/^\/paymentreport/) ? "nav-link px-2 text-white" : "nav-link px-2 text-secondary";

  const handleLogout = async(e) =>{
    logout();
    dispatch({ type: 'resetorders', payload: {}})
    dispatch({ type: 'resetorderitems', payload: {}})
    dispatch({ type:'resetpayments', payload: {}})
    navigate('/login');
  }

  const handleLocation = async(e) =>{
    let roles = auth?.roles
    let accessToken = auth?.accessToken
    let expiration = auth?.expiration
    setAuth({roles,accessToken,expiration});
    dispatch({ type: 'resetorders', payload: {}})
    dispatch({ type: 'resetorderitems', payload: {}})
    dispatch({ type:'resetpayments', payload: {}})
    navigate('/location');
  }

  return ( 

    <header className="p-3 bg-dark text-white">
    <div className="container" style={{marginLeft:'0px', marginRight:'0px', maxWidth:'1720px'}}>
      <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start"> 
        <a href="/" className="d-flex align-items-center mb-2 mb-lg-0 text-white text-decoration-none">
          <img src="images/logo_hindustan.png" alt="Hindustan Gold" width="70" height="70" />
        </a>

        <ul className="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0 ">
          {/* <li style={{display :  approverRoles.includes(auth?.roles) && auth?.selectedLocation ? 'block' : 'none'}}><Link to="/user" className={userClass}>Users</Link></li> */}
          <li style={{display :  requestorRoles.includes(auth?.roles) && auth?.selectedLocation ? 'block' : 'none'}}><Link to="/inventoryRequest" className={inventoryReqClass}>Request</Link></li>
          <li style={{display :  approverRoles.includes(auth?.roles) && auth?.selectedLocation ? 'block' : 'none'}}><Link to="/approve" className={approveClass}>Approval</Link></li>
          <li style={{display :  requestorRoles.includes(auth?.roles) && auth?.selectedLocation ? 'block' : 'none'}}><Link to="/history" className={historyClass}>History</Link></li>
          <li style={{display :  approverRoles.includes(auth?.roles) && auth?.selectedLocation ? 'block' : 'none'}}><Link to="/report" className={reportClass}>Report</Link></li>
          <li style={{display :  makerRoles.includes(auth?.roles)? 'block' : 'none'}}><Link to="/vendors" className={vendorClass}>Vendors</Link></li>
          <li style={{display :  makerRoles.includes(auth?.roles)? 'block' : 'none'}}><Link to="/paymentrequest" className={paymentRequestClass}>Request</Link></li>
          <li style={{display :  paymentApproverRoles.includes(auth?.roles)? 'block' : 'none'}}><Link to="/paymentapprove" className={paymentRequestApproveClass}>Approval</Link></li>
          <li style={{display :  makerRoles.includes(auth?.roles)? 'block' : 'none'}}><Link to="/paymenthistory" className={paymentRequestHistoryClass}>History</Link></li>
          {/* <li style={{display :  paymentApproverRoles.includes(auth?.roles)? 'block' : 'none'}}><Link to="/paymentreport" className={paymentReportClass}>Report</Link></li> */}
        </ul>

        <div className="d-grid gap-2 d-md-flex justify-content-md-end">
          {auth?.user}
          <button type="button" onClick={handleLocation} style={{display :  requestorRoles.includes(auth?.roles) && auth?.selectedLocation? 'block' : 'none'}} className="btn btn-info">{auth?.selectedLocation}</button> 
          <button type="button" onClick={handleLogout} style={{display :  requestorRoles.includes(auth?.roles) || makerRoles.includes(auth?.roles)? 'block' : 'none'}} className="btn btn-warning">Logout</button>
        </div>
      </div>
    </div>
    <InstallSnackbar />
  </header>
  )
}

export default Headerbar